var maxBy = {};
export {
  maxBy as __exports
};
//# sourceMappingURL=maxBy2.js.map
